import { DrawerFooter } from './drawer-footer';
import { DrawerList } from './drawer-list';
import { DrawerRoot } from './drawer-root';
import './side-drawer.scss';

export const SideDrawerBase = {
  Root: DrawerRoot,
  List: DrawerList,
  Footer: DrawerFooter,
};
